import { toAHEX, toColor } from '../../../utils/ColorTransformator'
import { IRequestValues as ICreateValues } from '../createRoom'
import { IRoom, RoomType } from '../index'
import { IRequestValues as IUpdateValues } from '../updateRoom'

type IRequestValues = IUpdateValues | ICreateValues | any

export default function mapFormToRequest(
  calendarId: number,
  room: IRequestValues & { id: IRoom[keyof Pick<IRoom, 'id'>] },
): IUpdateRequestBody | ICreateRequestBody {
  return {
    /* eslint-disable @typescript-eslint/camelcase */
    additional_beds: room.additionalBeds,
    additional_equipment: room.additionalEquipment,
    capacity: room.roomSize,
    city: room.city,
    coords_lat: room.coords_lat,
    coords_lng: room.coords_lng,
    custom_color: toAHEX(toColor(room.customColor)),
    description: room.description,
    doubleBed: room.doubleBed,
    id_calendar: calendarId,
    id_country: room.id_country,
    id_room: Number(room.id),
    name: room.name,
    position: room.position,
    post_code: room.post_code,
    room_service_bedding: room.serviceBedding,
    room_service_cleaning: room.serviceCleaning,
    room_service_cleaning_stage: room.serviceCleaningStage,
    room_service_towels: room.serviceTowels,
    show_in_search: String(room.widget),
    singleBed: room.singleBed,
    size: room.size === '' ? null : room.size,
    street: room.street,
    title: room.title,
    type: room.type,
    /* eslint-enable */
  }
}

export interface IUpdateRequestBody extends IRequestBody {
  id_room: number
  id_calendar: number
}

export interface ICreateRequestBody extends IRequestBody {
  id_calendar: number
  name: string
  capacity: number
  type: RoomType
}

export interface IRequestBody {
  id_calendar?: number
  name?: string
  title: string
  description?: string
  coords_lat?: string
  coords_lng?: string
  position?: number
  id_country?: number
  street?: string
  post_code?: string
  city?: string
  capacity?: number
  size?: any
  additional_equipment?: any
  type?: RoomType
  room_service_cleaning?: number
  room_service_bedding?: number
  room_service_towels?: number
  room_service_cleaning_stage?: number
  singleBed?: number
  doubleBed?: number
  show_calendar?: number
  additional_beds?: number
  show_in_search?: string
  custom_color?: string
  fixed_price?: undefined
}
